module.exports = __webpack_public_path__ + "img/Min-kamp_Bilde-av-bøkene.3ae30c0b.jpg";